import type { RouteObject } from 'react-router';
import { ComingSoon } from '@/app/system-pages';
import type { NavGroup } from '@/lib/nav/types';

/**
 * Each feature folder owns its routes: `features/<audience>/<section>/routes.tsx` exports
 * `routes: RouteObject[]` (paths relative to the audience root, pages loaded lazily).
 * They are collected here by glob, so adding a section never edits a shared file.
 * Any nav item without a route yet renders an honest "on its way" page.
 */
type RouteModule = { routes: RouteObject[] };

function firstSegment(path: string | undefined, index: boolean | undefined): string {
  return index ? '' : (path ?? '').split('/')[0] ?? '';
}

export function collectRoutes(modules: Record<string, RouteModule>, nav: readonly NavGroup[], root: string): RouteObject[] {
  const implemented = Object.values(modules).flatMap((module) => module.routes);
  const covered = new Set(implemented.map((route) => firstSegment(route.path, route.index)));

  const placeholders: RouteObject[] = nav
    .flatMap((group) => group.items)
    .filter((item) => {
      const segment = item.to === root ? '' : item.to.slice(root.length + 1).split('/')[0];
      return !covered.has(segment ?? '');
    })
    .map((item) =>
      item.to === root ? { index: true, element: <ComingSoon title={item.label} /> } : { path: item.to.slice(root.length + 1), element: <ComingSoon title={item.label} /> },
    );

  return [...implemented, ...placeholders];
}
